import axios from 'axios'
import apiUrl from '../../../constants'
import CryptoJS from 'crypto-js'
import VueElementLoading from 'vue-element-loading'
import Validator from 'vee-validate'
import PageTracker from '../../../common/PageTrackerHelper'
import Paginate from 'vuejs-paginate'
import { BasicSelect } from 'vue-search-select'
import rvpInscanPending from '../common/rvpInscanPending.vue'
import shortageShipments from '../common/shortageShipments.vue'
import commonService from '../../../common/common.service';
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { getOnePagerEnabledFlag } from "../../../../services/modules/printlabelservices.js";

export default {
  name: 'InScanRVPShipments',
  components: {
    VueElementLoading,
    CryptoJS,
    Paginate,
    BasicSelect,
    'pending-InscanRVP': rvpInscanPending,
    'shortage-shipments': shortageShipments,
    FormWizard,
    TabContent
  },
  props: [],
  mixins: [PageTracker],
  data() {
    return {
      flyerBarcode: '',
      weightType: '',
      length: '',
      breadth: '',
      height: '',
      physicalWeight: '',
      searchByShippingId: '',
      searchByShippingIdForShortage: '',
      shipmentType: '',
      searchByShippingIdMdl: '',
      shortageShippingIdMdl: '',
      hubid: null,
      pageNo: 1,
      pageNumber: 1,
      pagecount: 0,
      pageCount: 0,
      pageCountForShortage: 0,
      pageCountForShortageMdl: 0,
      pendingShipmentList: [],
      pendingShipmentListMdl: [],
      shortageShipmentListMdl: [],
      weightTypeOptions: [
        {
          text: '--Not Mandatory--',
          value: "NVW"
        },
        {
          text: 'Polybag',
          value: "PB"
        },
        {
          text: 'Custom-Polybag',
          value: "CP"
        },
        {
          text: 'Custom-Boxes',
          value: "CB"
        }
      ],
      selectedWeight: {},
      input: {},
      shipmentBarcode: '',
      openDimentionWeightTab: false,
      pendingShipmentModel: false,
      isPendingShipmentLoading: true,
      isPendingShipmentLoadingMdl: false,
      showSearchBar: false,
      onDimentionTabValidation: false,
      showPaginate: false,
      showShortagePaginate: false,
      isConfirmPhyWt: false,
      isConfirmVolWt: false,
      formLoading: false,
      flag: false,
      showPWcheckBox: false,
      showVWcheckBox: false,
      mdlFlag: true,
      shortageShipmentList: [],
      totalShipments: 0,
      total: 0,
      showShortagePaginateMdl: false,
      pageNoShortage: 1,
      pageNumShortageMdl: 1,
      isShortageShipmentLoadingMdl: false,
      shortageShipmentMdl: false,
      totalShortageShipMDl: null,
      shortageShippingMdl: '',
      modalType: 'RVP',
      ActiveTabIndex: 0,
      total3: '',
      checkTLQCProcessModal: false,
      QuestionObjList: [],
      isLoadingScanShipmentsTLQC: false,
      Savebuttondisable: true,
      isLoadingupload: false,
      shippingId: '',
      RVPShipment: '',
      Answer: [],
      RVPQCTable: [],
      isLoadingQc: false,
      isLoadingGetQuestions: false,
      isLoadingsave: false,
      isLoadingScanShipmentsTLQC: false,
      QcQuestionAns: {},
      QCSRValues: [],
      uploadMultipleImageModal: false,
      QuestionsObj: { Label: "", Type: "" },
      AnswerInradio: false,
      AnswerIntext: false,
      AnswerInnumber: false,
      AnswerType: '',
      QuestionObjList: [],
      TextAns: '',
      NumberAns: '',
      countAnswer: [],
      QuestionObjListSrValue: [],
      Savebuttondisable: true,
      // imageCount: 0,
      UploadedImgCount : 0,
      checkUploadImg: 0,
      srLoader: '',
      SetReadonlyMode: true,
      ClientPickupProductImages:[],
      SRPickDoneImages:[],
      IsClientPickImages:false,
      IsSRPickImages:false,
      UploadedImageArr: [],
      DeleteURL : '',
      openUploadImg : true,
      UploadImgLoader : false,
      UploadFilArr : [],
      loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      currentTabTitle: '',
      currentStep: 0,
      NewRES:[],
      ProductDetails:[],
      isSKUDAta: [],
      TabArray: [],
      themecolor: '#20a8d8',
      stepIndex: 0,
      inscanBtnDisabled: true,
      IsFlyerJacketEnabled: false,
      IsPrinterAvailable: true,
      // IsRtoRestrict: false,
      isShipInputBoxShown: true,
      restrictTLQCModal : false,
      restrictTLQCError : '',
      userDataKey : '',
      timeout: null,
      isManualEntryRestrict: false,
      ttl: 100,
      lastFlyerInputTime: Date.now(),
      isScanningForFlyer: false,
      scanTimeoutForFlyer: null,
      lastShipmentInputTime: Date.now(),
      isScanningForShipment: false,
      scanTimeoutForShipment: null,
    }
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userrole = userdetail.userrole;
    this.userid = userdetail.userid
    this.localusermailid = userdetail.username;
    this.hubid = userdetail.hubdetails[0]
    this.outsourcingid = userdetail.outsourcingid
    this.localuserEmail = userdetail.email;

    this.checkOnePagerEnabled();
    this.checkIsPrinterAvailable();
    this.getPendingShipmentListForPickupDone();
    // this.getShortageShipmentList();
    //scanner detection code
    if (!this.isManualEntryRestrict) {
    if (process.env.NODE_ENV === 'production') {
      let keyupFiredCount = 0
      var vm = this;
      $("#clearShipmentBarcode").keyup(this.DelayExecution(function (event) {
        let keycode = (event.keyCode ? event.keyCode : event.which);
        keyupFiredCount = keyupFiredCount + 1;
      }));

      $("#clearShipmentBarcode").blur(function (event) {
        if ($("#clearShipmentBarcode").val() == '') {
          return false;
        }
        if (keyupFiredCount <= 1) {
          vm.IsmannulCheck('B');
        } else {
          vm.IsmannulCheck('M');
        }
        keyupFiredCount = 0;
      });
    }
   }
    //scanner detection code

  },
  watch:{
   stepIndex(val){
      this.currentTabTitle = this.NewRES[val].ProductID
   console.log("this.currentTabTitle",this.currentTabTitle);
      this.GetUploadedImages();
    }
  },

  methods: {
    checkIsPrinterAvailable(){
      let payload = {
        "HubId" : this.hubid,
        "isPrinterAvailableCheck": true
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'external/get/sticker/restriction/flag',
        data: payload,
      })
        .then(async result => {
        if(result.data.code == 200){
            this.IsPrinterAvailable = result.data.data[0].isdtorestrictprinting;
            this.IsFlyerJacketEnabled = result.data.data[0].isflyerjacketenabled;
            // this.IsRtoRestrict = result.data.data[0].isrtorestrictprinting
          }
        else{
            this.IsPrinterAvailable = true;
            this.IsFlyerJacketEnabled = false;
            // this.IsRtoRestrict = false;
          }
          this.isShipmentInputBoxShown();
          this.ttl = result && result.data && result.data.restrictionRes.ttl ? result.data.restrictionRes.ttl : 200;
          this.isManualEntryRestrict = result && result.data && result.data.restrictionRes.isRestriction ? result.data.restrictionRes.isRestriction : false;
        console.log("Inscan IsPrinterAvailable flag::",this.IsPrinterAvailable);
        console.log("Inscan IsFlyerJacketEnabled flag::",this.IsFlyerJacketEnabled);
        console.log("isManualEntryRestrict::::::", this.isManualEntryRestrict + "TTL:::::::",this.ttl);
        })
    },

    isShipmentInputBoxShown(){
      if(this.IsFlyerJacketEnabled == true && this.IsPrinterAvailable == false){
        this.isShipInputBoxShown = false;
      }
      else{
        this.isShipInputBoxShown = true;
      }
    },
  async validateFormData(){
      let scope = `formw_${this.stepIndex}`;
      let val = await this.$validator.validateAll(scope);
      if(!val) {
        this.$alertify.error("All fields should be mandatory");
      }
      else if (this.UploadedImgCount != 4) {
        this.$alertify.error("4 Images are required!")
        return false;
      }
      return val;
    },
    IsmannulCheck(ScanType) {
      if (ScanType == 'B') {

      } else {
        this.shipmentBarcode = '';
        this.$refs.clearShipmentBarcode.focus();
        this.$alertify.error('Mannual input is not allowed. Use Barcode scanner.!');
      }
      console.log('ScanType', ScanType);
    },
    DelayExecution(f, delay) {
      var timer = null;
      return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = window.setTimeout(function () {
          f.apply(context, args);
        },
          delay || 30);
      };
    },
    changeTabPosition(event) {
      var charCode = (typeof event.which == "number") ? event.which : event.keyCode;
      if (/\D/.test(String.fromCharCode(charCode))) {
        this.$refs.clearFlyerBarcode.focus();
        return false;
      }
    },
    getShortageShipmentList() {
      this.isPendingShipmentLoading = true
      if (this.searchByShippingId) {
        document.getElementById('clearSearchField').value = '';
        this.searchByShippingId = ''
      }
      this.reqPayload = {
        "HubID": this.hubid,
        "ShipmentStatus": "SAReturnPending",
        "PageNo": this.searchByShippingIdForShortage ? 1 : this.pageNoShortage,
        "PageSize": 10,
        "ShipmentType": 'Reverse'
      }
      if (this.outsourcingid) {
        this.reqPayload.OutSourcingMasterId = this.outsourcingid;
      }
      if (this.searchByShippingIdForShortage) {
        this.reqPayload.ShippingID = this.searchByShippingIdForShortage;
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'rvpinscanshipment/getsareturnpendingagainsthub',
        data: this.reqPayload
      }).then(result => {
        this.isPendingShipmentLoading = false
        this.showShortagePaginate = true
        // console.log("Shortage Result--",result);
        if (result.data.code === 200) {
          this.totalShipments = result.data.result.TotalShipments
          this.shortageShipmentList = result.data.result.Shipments

          if (this.totalShipments < 10) {
            this.pageCountForShortage = 1
          } else {
            this.pageCountForShortage = Math.ceil(this.totalShipments / 10)
          }
        } else if (result.data.code === 202) {
          this.$alertify.error("No Data Found");
          return false;
        } else {
          this.$alertify.error(result.data.message);
          return false;
        }
      }).catch(error => {
        this.isPendingShipmentLoading = false;
        console.log("Error Details", error);
        return false
      })
    },
    switchTab(type) {
      this.modalType = type;
      if (type === 'RVP') {
        this.getPendingShipmentListForPickupDone()
      } else {
        this.getShortageShipmentList()
      }

    },
    async getPendingShipmentListForPickupDone() {
      this.isPendingShipmentLoading = true
      this.shipmentType = 'Reverse'
      if (this.searchByShippingIdForShortage) {
        document.getElementById('clearShortageSearchField').value = '';
        this.searchByShippingIdForShortage = ''
      }
      this.input = {
        "HubId": this.hubid,
        "PageNo": this.searchByShippingId ? 1 : this.pageNo,
        "ShipmentType": this.shipmentType,
        // "ShippingId":
      }
      if (this.searchByShippingId) {
        this.input.ShippingId = this.searchByShippingId
      }
      await axios({
        method: 'POST',
        url: apiUrl.api_url + 'rvpinscanshipment/getpendingshipmentlist',
        data: this.input
      }).then(async res => {
        // console.log("List--",res);
        this.isPendingShipmentLoading = false
        this.showPaginate = true
        this.isPendingShipmentLoadingMdl = false
        this.showSearchBar = true
        if (res.data.code === 204) {
          this.$alertify.error(res.data.message)
          return false
        }
        this.pendingShipmentList = res.data.data
        this.isPendingShipmentLoading = false
        if (this.mdlFlag) {
          this.pendingShipmentListMdl = res.data.data
        }
        this.total = res.data.total;
        this.total3 = res.data.total;
        if (this.total < 10) {
          this.pagecount = 1
          this.pageCount = 1
        } else {
          this.pagecount = Math.ceil(this.total / 10)
          this.pageCount = Math.ceil(this.total / 10)
        }
      }).catch(err => {
        this.showSearchBar = true
        this.isPendingShipmentLoading = false
        this.isPendingShipmentLoadingMdl = false
        console.log("Error Details", err);
        return false
      })
    },
    shipmentInScanForRVP() {
      this.input = {
        "HubID": this.hubid,
      }

      if(this.IsPrinterAvailable == false && this.flyerBarcode){
        this.input.flyerBarcode = this.flyerBarcode;
      }
      if(this.shipmentBarcode){
        this.input.ShippingID = this.shipmentBarcode.toString();
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'DayEndClosure/checkTLQCStatus',
        data: this.input
      })
        .then(result => {
          let ShippingId = this.shipmentBarcode ? this.shipmentBarcode : result.data.data.ShippingID;
          this.RVPShipment = ShippingId;

          this.srLoader = this.loader
          if (result.data.code == 204) {
            this.srLoader = '';
            this.$alertify.success(result.data.data.ScanMessage);
            this.ScanShipmentToGetQuestions(this.RVPShipment)
            this.srLoader = '';
            this.checkTLQCProcessModal = true;
          }else if(result.data.code == 210){
            this.restrictTLQCError = result.data.data.ScanMessage;
            this.restrictTLQCModal = true;
          }
          else {
            var payload = {}
            if (this.weightType === "NVW" || this.weightType === "PB" || this.weightType === "") {
              payload = {
                shippingID: ShippingId.toString(),
                flyerBarcode: this.flyerBarcode,
                originHubID: this.hubid,
                lastModifiedBy: this.localusermailid,
                physicalWeight: 0,
                shipmentLength: 0,
                shipmentBreadth: 0,
                shipmentHeight: 0,
                isConfirmInScan: true,
                isConfirmPhyWt: false,
                isConfirmVolWt: false,
                inScanFromDevice: this.weightType === "PB" ? "PB" : "NVW",
                statusMarkedFrom: "web",
                inscanType: 1
              }
            }
            if (this.weightType === "CB" || this.weightType === "CP") {
              payload = {
                shippingID: ShippingId.toString(),
                flyerBarcode: this.flyerBarcode,
                originHubID: this.hubid,
                lastModifiedBy: this.localusermailid,
                physicalWeight: this.physicalWeight,
                shipmentLength: this.length,
                shipmentBreadth: this.breadth,
                shipmentHeight: this.height,
                isConfirmInScan: true,
                isConfirmPhyWt: this.isConfirmPhyWt,
                isConfirmVolWt: this.isConfirmVolWt,
                inScanFromDevice: (this.weightType === "CB" ? "CB" : "CP"),
                statusMarkedFrom: "web",
                inscanType: 1
              }
            }
            this.formLoading = true
            axios({
              method: 'POST',
              url: apiUrl.api_url + 'rvpinscanshipment/manualshipmentinscanforrvp',
              data: payload
            }).then(res => {
              //this.reset()
              this.formLoading = false
              if (res.data.code === 200) {
                let TrackerInfo = {
                  projectname: "Lastmile-web",
                  type: "Web",
                  userid: this.userid,
                  username: this.localusermailid,
                  meta: {
                    "event": "manualShipmentInscanForRvp",
                    "ShippingID": ShippingId.toString(),
                    "flyerBarcode": this.flyerBarcode
                  }
                }
                this.PageTracker(TrackerInfo);
                this.$alertify.success(res.data.message)
                this.ScanShipmentsTLQC(ShippingId);
                this.reset()
                this.srLoader = ''
                return true
              } else {
                this.$alertify.error(res.data.message)
                this.srLoader = ''
                this.shipmentBarcode = '';
                this.flyerBarcode = '';
                document.getElementById('clearFlyerBarcode').value = '';
                if(this.IsPrinterAvailable == true){
                  this.$refs.clearShipmentBarcode.focus();
                }
                else{
                  this.$refs.clearFlyerBarcode.focus();
                }
                return false
              }
            }).catch(err => {
              this.formLoading = false
              console.log("Error Details", err);
              return false
            })
          }
        })
    },
    shipmentInScanForRVP2() {
      this.input = {
        "HubID": this.hubid,
      }

      if(this.IsPrinterAvailable == false && this.flyerBarcode){
        this.input.flyerBarcode = this.flyerBarcode;
      }
      if(this.shipmentBarcode){
        this.input.ShippingID = this.shipmentBarcode.toString();
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'DayEndClosure/checkTLQCStatus',
        data: this.input
      })
        .then(result => {
          let ShippingId = this.shipmentBarcode ? this.shipmentBarcode : result.data.data.ShippingID;
          this.RVPShipment = ShippingId;

          this.srLoader = this.loader
          if (result.data.code == 204) {
            this.srLoader = '';
            this.$alertify.success(result.data.data.ScanMessage);
            this.ScanShipmentToGetQuestions(this.RVPShipment)
            this.srLoader = '';
            this.checkTLQCProcessModal = true;
          }else if(result.data.code == 210){
            this.restrictTLQCError = result.data.data.ScanMessage;
            this.restrictTLQCModal = true;
          }
          else {
            this.ScanShipmentsTLQC(ShippingId);
          }
        })
    },
    manualshipmentinscanforrvp(ShippingId){
      var payload = {}
      if (this.weightType === "NVW" || this.weightType === "PB" || this.weightType === "") {
        payload = {
          shippingID: ShippingId.toString(),
          flyerBarcode: this.flyerBarcode,
          originHubID: this.hubid,
          lastModifiedBy: this.localusermailid,
          physicalWeight: 0,
          shipmentLength: 0,
          shipmentBreadth: 0,
          shipmentHeight: 0,
          isConfirmInScan: true,
          isConfirmPhyWt: false,
          isConfirmVolWt: false,
          inScanFromDevice: this.weightType === "PB" ? "PB" : "NVW",
          statusMarkedFrom: "web",
          inscanType: 1
        }
      }
      if (this.weightType === "CB" || this.weightType === "CP") {
        payload = {
          shippingID: ShippingId.toString(),
          flyerBarcode: this.flyerBarcode,
          originHubID: this.hubid,
          lastModifiedBy: this.localusermailid,
          physicalWeight: this.physicalWeight,
          shipmentLength: this.length,
          shipmentBreadth: this.breadth,
          shipmentHeight: this.height,
          isConfirmInScan: true,
          isConfirmPhyWt: this.isConfirmPhyWt,
          isConfirmVolWt: this.isConfirmVolWt,
          inScanFromDevice: (this.weightType === "CB" ? "CB" : "CP"),
          statusMarkedFrom: "web",
          inscanType: 1
        }
      }
      this.formLoading = true
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'rvpinscanshipment/manualshipmentinscanforrvp',
        data: payload
      }).then(res => {
        //this.reset()
        this.formLoading = false
        if (res.data.code === 200) {
          let TrackerInfo = {
            projectname: "Lastmile-web",
            type: "Web",
            userid: this.userid,
            username: this.localusermailid,
            meta: {
              "event": "manualShipmentInscanForRvp",
              "ShippingID": ShippingId.toString(),
              "flyerBarcode": this.flyerBarcode
            }
          }
          this.PageTracker(TrackerInfo);
          this.$alertify.success(res.data.message)
          //this.ScanShipmentsTLQC(ShippingId);
          this.reset()
          this.srLoader = ''
          return true
        } else {
          this.$alertify.error(res.data.message)
          this.srLoader = ''
          this.shipmentBarcode = '';
          this.flyerBarcode = '';
          document.getElementById('clearFlyerBarcode').value = '';
          if(this.IsPrinterAvailable == true){
            this.$refs.clearShipmentBarcode.focus();
          }
          else{
            this.$refs.clearFlyerBarcode.focus();
          }
          return false
        }
      }).catch(err => {
        this.formLoading = false
        console.log("Error Details", err);
        return false
      })
    },
    SelectWeight(cls) {
      this.weightType = cls.value
      this.selectedWeight = cls
      if (this.weightType === "PB" || this.weightType === "NVW") {
        this.openDimentionWeightTab = false
        this.onDimentionTabValidation = false
        this.$validator.reset()
        this.length = ''
        this.breadth = ''
        this.height = ''
        this.physicalWeight = ''
        document.getElementById("lengthid").value = ''
        document.getElementById("breadthid").value = ''
        document.getElementById("heightid").value = ''
        document.getElementById("physicalWeightId").value = ''
        this.showPWcheckBox = false
        this.isConfirmPhyWt = false
      } else {
        this.openDimentionWeightTab = true
        this.onDimentionTabValidation = true
      }
    },
    openModelPendingShipmentList(tab) {
      if (tab === 'RVP') {
        this.mdlFlag = false
        this.pendingShipmentModel = true
        if (this.flag) {
          this.flag = false
          this.getShipmentbyShippingIdMdl()
        }
      } else {
        this.shortageShipmentMdl = true
        this.isShortageShipmentLoadingMdl = true;
        this.getShortageShipmentListMdl();
      }
    },
    closePendingShipmentModel(tabtype) {
      if (tabtype === 'RVPMdl') {
        this.pendingShipmentModel = false
        if (this.searchByShippingIdMdl) {
          document.getElementById('clearSearchFieldMdl').value = ''
          this.searchByShippingIdMdl = ''
          this.flag = true
        }
      } else {
        this.shortageShipmentMdl = false
        if (this.shortageShippingIdMdl) {
          document.getElementById('ShortageShippingMdl').value = ''
          this.shortageShippingIdMdl = ''
        }
      }

    },
    getPaginationData(pageNum) {
      this.pageNo = pageNum
      if (this.searchByShippingId) {
        document.getElementById('clearSearchField').value = '';
        this.searchByShippingId = ''
      }
      this.getShipmentbyShippingId()
    },
    getPaginationDataForShortage(pageNum) {
      this.pageNoShortage = pageNum
      if (this.searchByShippingIdForShortage) {
        document.getElementById('clearShortageSearchField').value = '';
        this.searchByShippingIdForShortage = ''
      }
      this.getShortageShipmentList()
    },
    getPaginationDataMdl(pageNum) {
      this.pageNumber = pageNum
      if (this.searchByShippingIdMdl) {
        document.getElementById('clearSearchFieldMdl').value = '';
        this.searchByShippingIdMdl = ''
      }
      this.getShipmentbyShippingIdMdl()
    },
    getShortagePaginationData(pageNo) {
      this.pageNumShortageMdl = pageNum
      if (this.shortageShippingIdMdl) {
        document.getElementById('ShortageShippingMdl').value = ''
        this.shortageShippingIdMdl = ''
      }
      this.getShortageShipmentListMdl();
    },
    getShipmentbyShippingId() {

      this.isPendingShipmentLoading = true
      this.shipmentType = 'Reverse'
      this.input = {
        "HubId": this.hubid,
        "PageNo": this.searchByShippingId ? 1 : this.pageNo,
        "ShipmentType": this.shipmentType,
        // "ShippingId": this.searchByShippingId
      }
      if (this.searchByShippingId) {
        this.input.ShippingId = this.searchByShippingId
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'rvpinscanshipment/getpendingshipmentlist',
        data: this.input
      }).then(async res => {
        this.showPaginate = true
        this.isPendingShipmentLoading = false
        if (res.data.code === 204) {
          this.$alertify.error(res.data.message)
          return false
        }
        this.pendingShipmentList = res.data.data

        var total2 = res.data.total
        if (total2 < 10) {
          this.pagecount = 1
        } else {
          this.pagecount = Math.ceil(total2 / 10)
        }
      }).catch(err => {
        this.isPendingShipmentLoading = false
        console.log("Error Details", err);
        return false
      })
    },
    getShipmentbyShippingIdMdl() {
      this.isPendingShipmentLoadingMdl = true
      this.shipmentType = 'Reverse'
      this.input = {
        "HubId": this.hubid,
        "PageNo": this.searchByShippingIdMdl !== '' ? 1 : this.pageNumber,
        "ShipmentType": this.shipmentType,
      }
      if (this.searchByShippingIdMdl) {
        this.input.ShippingId = this.searchByShippingIdMdl;
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'rvpinscanshipment/getpendingshipmentlist',
        data: this.input
      }).then(res => {
        this.showPaginate = true
        this.isPendingShipmentLoadingMdl = false
        if (res.data.code === 204) {
          this.$alertify.error(res.data.message)
          return false
        }
        this.pendingShipmentListMdl = res.data.data
        this.total3 = res.data.total
        if (this.total3 < 10) {
          this.pageCount = 1
        } else {
          this.pageCount = Math.ceil(this.total3 / 10)
        }
      }).catch(err => {
        this.isPendingShipmentLoadingMdl = false
        console.log("Error Details", err);
        return false
      })
    },
    getShortageShipmentListMdl() {
      this.isShortageShipmentLoadingMdl = true
      this.reqPayload = {
        "HubID": this.hubid,
        "ShipmentStatus": "SAReturnPending",
        "PageNo": this.shortageShippingIdMdl ? 1 : this.pageNumShortageMdl,
        "PageSize": 10,
        "ShipmentType": 'Reverse'
      }
      if (this.outsourcingid) {
        this.reqPayload.OutSourcingMasterId = this.outsourcingid;
      }
      if (this.shortageShippingIdMdl) {
        this.reqPayload.ShippingID = this.shortageShippingIdMdl
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'rvpinscanshipment/getsareturnpendingagainsthub',
        data: this.reqPayload
      }).then(result => {
        this.isShortageShipmentLoadingMdl = false
        this.showShortagePaginateMdl = true
        // console.log("shortage modal list--",result);
        if (result.data.code === 200) {
          this.totalShortageShipMDl = result.data.result.TotalShipments
          this.shortageShipmentListMdl = result.data.result.Shipments

          if (this.totalShortageShipMDl < 10) {
            this.pageCountForShortageMdl = 1
          } else {
            this.pageCountForShortageMdl = Math.ceil(this.totalShortageShipMDl / 10)
          }
        } else if (result.data.code === 202) {
          this.$alertify.error("No Data Found");
          return false
        } else {
          this.$alertify.error(result.data.message);
          return false;
        }
      }).catch(error => {
        this.isShortageShipmentLoadingMdl = false;
        console.log("Error Details", error);
        return false
      })
    },
    refresh(tabtype) {
      if (tabtype === 'RVP') {
        if (this.searchByShippingId) {
          document.getElementById("clearSearchField").value = ''
          this.searchByShippingId = ''
        }
        this.getPendingShipmentListForPickupDone()
      } else if (tabtype === 'RVPModal') {
        if (this.searchByShippingIdMdl) {
          document.getElementById('clearSearchFieldMdl').value = '';
          this.searchByShippingIdMdl = ''
        }
        this.getShipmentbyShippingIdMdl()
      } else if (tabtype === 'SSMdl') {
        if (this.shortageShippingIdMdl) {
          document.getElementById('ShortageShippingMdl').value = '';
          this.shortageShippingIdMdl = '';
        }
        this.getShortageShipmentListMdl();
      } else {
        if (this.searchByShippingIdForShortage) {
          document.getElementById('clearShortageSearchField').value = ''
          this.searchByShippingIdForShortage = ''
        }
        this.getShortageShipmentList();
      }
    },
    checkPW() {
      if (this.physicalWeight) {
        var num = parseInt(this.physicalWeight)
        if (num >= 20) {
          this.showPWcheckBox = true
        } else {
          this.showPWcheckBox = false
          this.isConfirmPhyWt = false
        }
      }
    },
    submitForm(scope) {
      
      if (this.showPWcheckBox && this.isConfirmPhyWt === false) {
        this.$alertify.error("Please Confirm Physical Weight")
        this.isConfirmPhyWt = false
        return false
      } else if (this.physicalWeight > 150) {
        this.$alertify.error("Physical weight of an E-Com shipment cannot be more than 150 Kgs")
        return false
      }
      if ((this.length * this.breadth * this.height) / 6000 >= 20) {
        this.showVWcheckBox = true
        if (this.showVWcheckBox && this.isConfirmVolWt === false) {
          this.$alertify.error("Please Confirm Volumetric Weight")
          return false
        }
      } else {
        this.isConfirmVolWt = false
        this.showVWcheckBox = false
      }
      this.$validator.validateAll(scope).then(res => {
        if (res) {
          this.shipmentInScanForRVP2()
        } else {
          this.$alertify.error("Invalid Input Data")
          return false
        }
      }).catch(err => {
        console.log("Error Details", err);
        return false
      })
    },
    reset() {
      this.$validator.reset()
      if(document.getElementById('clearShipmentBarcode')){
        document.getElementById('clearShipmentBarcode').value = ''
      }
      document.getElementById('clearFlyerBarcode').value = ''
      document.getElementById("lengthid").value = ''
      document.getElementById("breadthid").value = ''
      document.getElementById("heightid").value = ''
      document.getElementById("physicalWeightId").value = ''
      this.flyerBarcode = ''
      this.shipmentBarcode = ''
      this.physicalWeight = ''
      this.length = ''
      this.breadth = ''
      this.height = ''
      this.showPWcheckBox = false
      this.isConfirmPhyWt = false
      //this.openDimentionWeightTab = false
      this.onDimentionTabValidation = false
      //this.selectedWeight = {}
      this.isConfirmVolWt = false
      this.showVWcheckBox = false
      if(this.IsPrinterAvailable == true){
        this.$refs.clearShipmentBarcode.focus();
      }
      else{
        this.$refs.clearFlyerBarcode.focus();
      }
    },
    resetAll() {
      this.selectedWeight = {},
        this.openDimentionWeightTab = false
      this.reset();
    },

    //Check whether shipment want TLQC or Not

    async checkTLQCStatus(shippingId,flyerbarcode) {
      this.closeModel();
      this.srLoader = this.loader
      if (this.IsPrinterAvailable && (shippingId == '' || flyerbarcode == '')) {
        this.srLoader = '';
        this.flyerBarcode = '';
        document.getElementById('clearFlyerBarcode').value = '';
        this.$refs.clearShipmentBarcode.focus();
        this.$alertify.error("Please enter ShippingId and FlyerBarcode")
        this.srLoader = '';
        return;
      }
      else if (!this.IsPrinterAvailable && !flyerbarcode) {
        this.srLoader = ''
        this.$alertify.error("Please enter FlyerBarcode")
        this.srLoader = '';
        return;
      }
      if(!flyerbarcode.toLowerCase().startsWith('r')){
        this.$alertify.error("Please enter correct FlyerBarcode")
        this.srLoader = '';
        return;
      }      
      // await commonService.validateParentAwbArray(this.shippingId.split(/[\n,]+/)).then(shipmentValidation => {
      //   if (shipmentValidation) {
      //     this.srLoader = this.loader
      //     this.EmptyResult = false;
      //     let validShipment = shipmentValidation.valid
      //     let invalidShipment = shipmentValidation.invalid
      //     if (invalidShipment && invalidShipment.length > 0) {
      //       this.EmptyResult = true;
      //       this.currentInvalidShipment = invalidShipment.toString();
      //       this.srLoader = ''
      //       this.ShowTable = false;
      //     } else {
      //       this.srLoader = ''
      //       this.currentValidShipment = validShipment;
      //     }
      //   }
      // })
      this.input = {
        "HubID": this.hubid,
      }

      if(this.IsPrinterAvailable == false && flyerbarcode){
        this.input.flyerBarcode = flyerbarcode;
      }
      if(shippingId){
        this.input.ShippingID = shippingId.toString();
      }
      await axios({
        method: 'POST',
        url: apiUrl.api_url + 'DayEndClosure/checkTLQCStatus',
        data: this.input
      })
        .then(async result => {
          this.RVPShipment = shippingId ? shippingId : result.data.data.ShippingID;
          this.srLoader = this.loader;
          let successCodesArray = [200,202,203,205];

          if (successCodesArray.includes(result.data.code)) {
            this.srLoader = '';
            this.inscanBtnDisabled = false;
            this.$alertify.success(result.data.data.ScanMessage);
          }
          else if (result.data.code == 204) {
            this.srLoader = ''
            this.$alertify.success(result.data.data.ScanMessage);
            await this.ScanShipmentToGetQuestions(this.RVPShipment);
            this.inscanBtnDisabled = false;
            this.checkTLQCProcessModal = true;
          }else if(result.data.code == 210){
            this.restrictTLQCError = result.data.data.ScanMessage;
            this.restrictTLQCModal = true;
          }
          else {
            this.srLoader = '';
            this.inscanBtnDisabled = true;
            this.$alertify.error(result.data.data.ScanMessage);
          }  
        })
    },
    sumbitQCFormDetails() {
      for (let i = 0; i < this.QCSRValues.length; i++) {
        if (this.ProductDetails.find(o => o.ProductID == this.QCSRValues[i].ProductID)) {
          let existObj = this.ProductDetails.find(o => o.ProductID == this.QCSRValues[i].ProductID)
          let existIndex = this.ProductDetails.indexOf(existObj);
          this.ProductDetails[existIndex].TLQCParameters.push({
            Label: this.QCSRValues[i].Lable,
            Value: this.QCSRValues[i].Value
          })
        } else {
          let productObj = {
            ProductID: this.QCSRValues[i].ProductID,
            TLQCParameters: []
          }
          productObj.TLQCParameters.push({
            Label: this.QCSRValues[i].Lable,
            Value: this.QCSRValues[i].Value
          })
          this.ProductDetails.push(productObj)
        }
      }
      for (let i = 0; i < this.NewRES.length; i++) {
        if (this.ProductDetails.find(obj => obj.ProductID == this.NewRES[i].ProductID)) {
      }else{
          let productObj = {
            ProductID: this.NewRES[i].ProductID,
            TLQCParameters: []
          }
          this.ProductDetails.push(productObj)
        }
      }
      // console.log("QCSRValues",this.QCSRValues);
      // console.log("ProductDetails",this.ProductDetails);
      this.Savedata();
    },

    async ScanShipmentToGetQuestions(shippingid) {
      this.isLoadingGetQuestions = true
      this.input = {
        "ShippingID": this.RVPShipment,
        "HubId": this.hubid,
      }
      await axios({
        method: 'POST',
        url: apiUrl.api_url + 'DayEndClosure/getRVPShipmentDetails',
        data: this.input
      })
        .then(async result => {
          if (result.data.code == 200) {
            this.isSKUDAta = result.data.data
              this.NewRES =  result.data.data.ProductDetails;
            //  console.log("APIRES",this.NewRES);

               if(this.NewRES[0].ProductID == null){
              this.NewRES[0].ProductID = ''
            }
            this.currentTabTitle = this.NewRES[0].ProductID
            //  console.log("currentTabTitle",this.currentTabTitle);
            this.GetUploadedImages();
            this.isLoadingGetQuestions = false;
          }
        }).catch(err => {
          console.log("Error Details", err);
          return false
        })
    },
    AnsYes(item,Pid) {
      this.QcQuestionAns[item] = "Yes"
      let QCSRValuesobj = {}
      let resultElement = this.QCSRValues.filter(element => {
        if (element.Lable === item && element.ProductID === Pid) {
          return element;
      }else{
          return false;
        }
      })
      if (Object.keys(resultElement).length) {
    let i = this.QCSRValues.findIndex(function(itm) {
          return itm.Lable == item && itm.ProductID == Pid;
        });
        this.QCSRValues[i].Value = "Yes"
        this.QCSRValues[i].ProductID = Pid
      }
      else {
        QCSRValuesobj.Lable = item
        QCSRValuesobj.Value = "Yes"
        QCSRValuesobj.ProductID = Pid
        this.QCSRValues.push(QCSRValuesobj)
      }
    },
    AnsNo(item,Pid) {
      this.QcQuestionAns[item] = "No"
      let QCSRValuesobj = {}
      let resultElement = this.QCSRValues.filter(element => {
        if (element.Lable === item && element.ProductID === Pid) {
          return element;
        }else{
          return false;
        }
      })
      if (Object.keys(resultElement).length) {
      let i = this.QCSRValues.findIndex(function(itm) {
          return itm.Lable == item && itm.ProductID == Pid;
        });
        this.QCSRValues[i].Value = "No"
        this.QCSRValues[i].ProductID = Pid
      }
      else {
        QCSRValuesobj.Lable = item
        QCSRValuesobj.Value = "No"
        QCSRValuesobj.ProductID = Pid
        this.QCSRValues.push(QCSRValuesobj)
      }
    },
    AnsText(value,item,Pid) {
      this.QcQuestionAns[item] = value
      let QCSRValuesobj = {}
      let resultElement = this.QCSRValues.filter(element => {
        if (element.Lable === item && element.ProductID === Pid) {
          return element;
      }else{
          return false;
        }
      })
      if (Object.keys(resultElement).length) {
        let i = this.QCSRValues.findIndex(function(itm) {
          return itm.Lable == item && itm.ProductID == Pid;
        });
        this.QCSRValues[i].Value = value
        this.QCSRValues[i].ProductID = Pid
      }
      else {
        QCSRValuesobj.Lable = item
        QCSRValuesobj.Value = value
        QCSRValuesobj.ProductID = Pid
        this.QCSRValues.push(QCSRValuesobj)
      }
      if (value.length == 0) {
        let delObj = this.QCSRValues.findIndex(o => o.Lable === item)
        this.QCSRValues.splice(delObj , 1)
      }
      this.TabAnsArray = this.QCSRValues
    },
    AnsNumber(value,item,Pid) {
      this.QcQuestionAns[item] = value
      let QCSRValuesobj = {}
      let resultElement = this.QCSRValues.filter(element => {
        if (element.Lable === item && element.ProductID === Pid) {
          return element;
      }else{
          return false;
        }
      })
      if (Object.keys(resultElement).length) {
        let i = this.QCSRValues.findIndex(function(itm) {
          return itm.Lable == item && itm.ProductID == Pid;
        });
        this.QCSRValues[i].Value = value
        this.QCSRValues[i].ProductID = Pid
      }
      else {
        QCSRValuesobj.Lable = item
        QCSRValuesobj.Value = value
        QCSRValuesobj.ProductID = Pid
        this.QCSRValues.push(QCSRValuesobj)
      }
      if (value.length == 0) {
        let delObj = this.QCSRValues.findIndex(o => o.Lable === item)
        this.QCSRValues.splice(delObj , 1)
      }
      this.TabAnsArray = this.QCSRValues
    },

    closeModel() {
      this.stepIndex = 0;
      this.QCSRValues = []
      this.NewRES = []
      this.Answer = []
      this.TLQCParameters = []
      this.ProductDetails = []
      this.checkTLQCProcessModal = false;
      this.UploadedImageArr = []
      this.isLoadingGetQuestions = false;
      this.srLoader = '';
      this.currentTabTitle = '';
    },
    closeModelRestrict() {
      this.restrictTLQCModal = false;
      this.restrictTLQCError = '';
    },
    Savedata() {
      this.isLoadingsave = true;
      this.input = {
        "ShippingID": this.RVPShipment,
        "HubId": this.hubid,
        "DeliveryUserId": this.srId2,
          "LastModifiedBy":this.localuserEmail,
          "ProductDetails":this.ProductDetails,
          "MarkedFrom":"Web"
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'DayEndClosure/saveTLQCQuestion',
        data: this.input
      })
        .then(result => {
          if (result.data.code == 200) {
            this.$alertify.success("Saved successfully!!");
            this.closeModel();
          }
          else if (result.data.code == 202) {
            this.isLoadingsave = false;
            this.$alertify.error("TL QC already done for the shipment")
            this.countAnswer = []
          }
          else if (result.data.code == 203) {
            this.isLoadingsave = false;
            this.$alertify.error("Cannot do TL QC as questions are not present")
            this.countAnswer = []
          }
          else if (result.data.code == 204) {
            this.isLoadingsave = false;
            this.$alertify.error("Invalid Shipment")
            this.countAnswer = []
          }
          else {
            this.isLoadingsave = false;
            this.$alertify.error("No question answers to save")
            this.countAnswer = []
          }
          this.RVPShipment = ''
        })
    },

    async uploadPODMultipleImage(RVPShipment) {
      this.GetUploadedImages(RVPShipment);
      this.RVPShipment = RVPShipment;
      if (this.RVPShipment != "") {
        this.checkUploadImg = 1
        this.checkTLQCProcessModal = true
      } else {
        this.checkUploadImg = 0
        this.$alertify.error("Please Enter RVP Shipment for scan");
      }
    },
    openuploadMultipleImageModal() {
      this.uploadMultipleImageModal = true;
    },
    closeuploadMultipleImageModal() {
      this.uploadMultipleImageModal = false;
      this.checkTLQCProcessModal = true;
    },
    ClearuploadImageFile() {
      this.file = '';
      this.formData11 = '';
      this.validated = true
      this.uploadImage1 = {};
      this.QCSRValues = []
      this.Answer = []
    },

    //Upload multiple files
    async handleFileUpload(event) {
      this.isLoadingupload = true;
      try {
        if (this.RVPShipment) {
          let uploadFile = event.target.files;
          this.UploadFilArr = [];

          this.podimagearray = []
          if (uploadFile.length > 4) {
            this.$alertify.error("Cannot Upload more than 4 images .");
            this.isLoadingupload = false;
            return false;
          }else if(this.UploadedImgCount == 4 ){
            this.$alertify.error("Cannot Upload more than 4 images .");
            this.isLoadingupload = false;
          }else if(this.UploadedImgCount == 3 && uploadFile.length > 1 ){
            this.$alertify.error("Please select only one image.");
            this.isLoadingupload = false;
          }else if(this.UploadedImgCount == 2 && uploadFile.length > 2 ){
            this.$alertify.error("Please select only two images.");
            this.isLoadingupload = false;
          }else if(this.UploadedImgCount == 1 && uploadFile.length > 3 ){
            this.$alertify.error("Please select only three images.");
            this.isLoadingupload = false;
          }else{
            let PromisSuccess = []
          for(var key = 0; key < uploadFile.length; key++){
              let formData = new FormData();

              if (key >= 0) {
                let sanitizename;
              sanitizename = this.sanitizeFileName(key,uploadFile[key].name);
              const myRenamedFile = new File([uploadFile[key]], sanitizename, {type: uploadFile[key].type});
                this.UploadFilArr.push(myRenamedFile);
                if (this.UploadFilArr[key].type != "image/jpeg" && this.UploadFilArr[key].type != "image/jpg" && this.UploadFilArr[key].type != "image/png") {
                  this.$alertify.error("Please upload only valid file format(.jpeg, .png, .jpg)");
                  this.isLoadingupload = false;
                  this.closeuploadMultipleImageModal()
                }
              }
              if (this.UploadFilArr[key].size > (1024 * 1024 * 5)) {
                this.$alertify.error(`${this.UploadFilArr[key].name} size is greater than 5MB`, "", "error");
                this.isLoadingupload = false;
                this.closeuploadMultipleImageModal()
              }
              else {
              if(this.isSKUDAta.IsSku == 0){
                  formData.append("ShippingID", this.RVPShipment.trim());
                  formData.append("file", this.UploadFilArr[key]);
                }
              else if(this.isSKUDAta.IsSku == 1){
                  formData.append("ShippingID", this.RVPShipment.trim());
              if(this.currentTabTitle)formData.append("ProductID",this.currentTabTitle.trim());
                  formData.append("file", this.UploadFilArr[key]);
                }
                PromisSuccess.push(this.UploadImagesfun(formData));
              }
            }
            Promise.all(PromisSuccess).then(async result => {
            if(result.success = true) {
                this.$alertify.success("Images Uploaded Successfully");
                this.isLoadingupload = false;
              } else {
                this.$alertify.error("Images could not be uploaded.");
                this.isLoadingupload = false;
              }
              this.GetUploadedImages();
              this.closeuploadMultipleImageModal()
            })
          }
        } else {
          this.$alertify.error("Not getting Shipment id.");
          this.isLoadingupload = false;
          this.closeuploadMultipleImageModal()
        }
      } catch (error) {
        console.log("Error", error);
        this.isLoadingupload = false
      }
    },
    // updateEODBatchStatus(DeliveryUserID,HubID,LastModifiedBy){
    //   this.input = {
    //     "DeliveryUserID": DeliveryUserID,
    //     "HubID": HubID,
    //     "LastModifiedBy":LastModifiedBy
    //   }
    //   axios({
    //     method: 'POST',
    //     url: apiUrl.api_url + 'DayEndClosure/updateEODBatchStatus',
    //     data: this.input
    //   })
    //   .then(respons => {
    //     console.log('response of updateEODBatchStatus',respons);
    //   })
    // },

    UploadImagesfun(formData) {
      return new Promise( (resolve, reject) => {
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'DayEndClosure/uploadS3Image',
          data: formData,
        })
          .then(result => {
            if (result.status == 200) {
            resolve({success:true});
            } else {
            resolve({success:false});
            }
          }, error => {
          resolve({success:false});
          })
      });
    },
    //Get Uploaded iamges from s3
    GetUploadedImages() {
      this.isLoadingupload = true;
      this.UploadedImageArr = [];
      this.UploadedImgCount = 0;
      let input = {}
      if(this.isSKUDAta.IsSku == 0){
        input.ShippingID = this.RVPShipment.trim()
      }
      else if(this.isSKUDAta.IsSku == 1){
        if (this.currentTabTitle) input.ProductID = this.currentTabTitle.trim();
        input.ShippingID = this.RVPShipment.trim()
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'DayEndClosure/GetUploadedQCCheckS3Images',
        data: input
      })
        .then(result => {
          if (result.data.code == 200) {
            this.UploadedImageArr = result.data.data;
            this.UploadedImgCount = this.UploadedImageArr.length
            this.isLoadingupload = false;
          }
            else{
            this.UploadedImgCount = this.UploadedImageArr.length
            this.$alertify.error(result.data.message)
            this.isLoadingupload = false;
          }
        })
    },
    RemoveImage(item){
      let splitURL = item.ImageUrl.split("?");
      this.DeleteURL = splitURL[0]
      this.input = {
        "ImageUrl" : this.DeleteURL,
      }
      // console.log("DeleteURL",this.DeleteURL);
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'DayEndClosure/DeleteQCCheckS3Image',
        'data': this.input,
      })
        .then(result => {
          if (result.data.code == 200) {
            this.$alertify.success('File Removed Successfully');
            item.ImageUrl = '';
            this.file = '';
            this.GetUploadedImages();
          }
            else{
            this.$alertify.error(result.data.message)
          }
        })
    },
    ScanShipmentsTLQC(RVPShipment) {
      this.isLoadingScanShipmentsTLQC = true;
      this.RVPShipment = RVPShipment;
      if (this.RVPShipment == '') {
        this.$alertify.error("Please enter ShippingId")
        this.isLoadingScanShipmentsTLQC = false;
      }
      else {
        this.input = {
          "ShippingID": this.RVPShipment.trim(),
          "LastModifiedBy": this.localusermailid,
          "IsInscan": true,
          "IsRVPQCCheck":true
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'DayEndClosure/updateEODInscanShipment',
          data: this.input
        })
          .then(response => {
            if (response.data.code == 200 || response.data.data.ScanMessage == "Shipment already scanned in Day End Closure" || response.data.data.ScanMessage == "Shipment is not eligible for Day End Closure") {
              this.isLoadingScanShipmentsTLQC = false;
              this.manualshipmentinscanforrvp(RVPShipment);
              this.shippingId = '',
                this.comments = ''
              //this.updateEODBatchStatus(this.srId2,this.hubid,this.localuserEmail);
            }
            else {
              this.isLoadingScanShipmentsTLQC = false;
              //this.$alertify.error("Error While scanning rvp shipment!");
              this.$alertify.error(response.data.data.ScanMessage);
              this.shippingId = '',
                this.comments = ''
            }
            this.reset()
            this.srLoader = ''
            return true
          })
      }
    },
    handleShipmentKeyDown(event) {
      clearTimeout(this.timeout);
      if (event.key === 'Enter' || event.key === 'Tab' || event.keyCode === 13 || event.keyCode === 9) {
        this.$refs.clearFlyerBarcode.focus(); // Focus on the flyer input box
        return false;
      } else {
        const effectiveDelay = this.ttl != null && this.ttl != undefined ? this.ttl : 200;
        return this.timeout = setTimeout(() => {
          this.shipmentBarcode = '';
          this.$alertify.error("Please Scan Shipment barcode.");
        }, effectiveDelay);
      }
    }
    ,
    async handleFlyerKeyDown(event) {
      clearTimeout(this.timeout);
      if (event.key === 'Enter' || event.key === 'Tab' || event.keyCode === 13 || event.keyCode === 9) {
        await this.checkTLQCStatus(this.shipmentBarcode, this.flyerBarcode)
        return false;
      } else {
        const effectiveDelay = this.ttl != null && this.ttl != undefined ? this.ttl : 200;
        return this.timeout = setTimeout(() => {
          console.log('Manual entry detected. Clearing input...');
          this.flyerBarcode = '';
          this.$alertify.error("Please Scan Flyer barcode.")
          return false;
        }, effectiveDelay);
      }
    },

    detectKeyPressForShipment(event) {
      let currentTime = Date.now();
      // Ignore Enter (13) and Tab (9)
      if (event.keyCode === 13 || event.keyCode === 9) {
        return;
      }

      // First input detected (reset state)
      if (this.lastShipmentInputTime === null) {
        this.lastShipmentInputTime = currentTime;
        this.isScanningForShipment = true; // Assume scanner initially
      }
      let timeDiff = currentTime - this.lastShipmentInputTime;
      // If input is very fast, assume scanner is active
      if (timeDiff <= this.ttl) {
        this.isScanningForShipment = true;
      } else {
        this.isScanningForShipment = false;
      }
      this.lastShipmentInputTime = currentTime;
      // Set a timeout to detect when the scan is complete
      clearTimeout(this.scanTimeoutForShipment);
      this.scanTimeoutForShipment = setTimeout(() => {
        if (this.isScanningForShipment && this.shipmentBarcode.length > 5) {
          this.processScanForShipment();
        } else {
          this.handleManualInputForShipment();
        }
      }, this.ttl); // Adjust timing based on your scanner speed
    },
    async processScanForShipment() {
      this.$refs.clearFlyerBarcode.focus();
      return
    },
    handleManualInputForShipment() {
      this.shipmentBarcode = "";
      this.$alertify.error("Please Scan Shipment Barcode.");
    },
    detectKeyPressForFlyer(event) {
      let currentTime = Date.now();
      // Ignore Enter (13) and Tab (9)
      if (event.keyCode === 13 || event.keyCode === 9) {
        return;
      }

      // First input detected (reset state)
      if (this.lastFlyerInputTime === null) {
        this.lastFlyerInputTime = currentTime;
        this.isScanningForFlyer = true; // Assume scanner initially
      }
      let timeDiff = currentTime - this.lastFlyerInputTime;
      // If input is very fast, assume scanner is active
      if (timeDiff <= this.ttl) {
        this.isScanningForFlyer = true;
      } else {
        this.isScanningForFlyer = false;
      }
      this.lastFlyerInputTime = currentTime;
      // Set a timeout to detect when the scan is complete
      clearTimeout(this.scanTimeoutForFlyer);
      this.scanTimeoutForFlyer = setTimeout(() => {
        if (this.isScanningForFlyer && this.flyerBarcode.length > 5) {
          this.processScanForFlyer();
        } else {
          this.handleManualInputForFlyer();
        }
      }, this.ttl);
    },
    async processScanForFlyer() {
      await this.checkTLQCStatus(this.shipmentBarcode, this.flyerBarcode)
      return
    },
    handleManualInputForFlyer() {
      this.flyerBarcode = "";
      this.$alertify.error("Please Scan Flyer Barcode.");
    },
    // updateEODBatchStatus(DeliveryUserID,HubID,LastModifiedBy){
    //   this.input = {
    //     "DeliveryUserID": DeliveryUserID,
    //     "HubID": HubID,
    //     "LastModifiedBy":LastModifiedBy
    //   }
    //   axios({
    //     method: 'POST',
    //     url: apiUrl.api_url + 'DayEndClosure/updateEODBatchStatus',
    //     data: this.input
    //   })
    //   .then(respons => {
    //     console.log('response of updateEODBatchStatus',respons);
    //   })
    // }

    sanitizeFileName(key, fileNameWithExt){
      var fileExt = fileNameWithExt.split('.').pop();
      // let dotLastIndex = fileNameWithExt.lastIndexOf('.');
      // let finalNameWithoutExtension = fileNameWithExt.substring(0, dotLastIndex);
      // let sanitizedfileName = finalNameWithoutExtension.replace(/[^a-zA-Z0-9']/g, '').replace(' ', '');
      let sanitizenametemp = key +'.' + fileExt;
      return sanitizenametemp;
    },

    /* Get One Pager Configuration here */
    checkOnePagerEnabled() {
      let RequestForOnePagerFlag = {
        "hubId": this.hubid
      };
      getOnePagerEnabledFlag(RequestForOnePagerFlag, (result) => {
        try {
          if (result.data.code == 200) {
            if (result.data.data == true) {
              this.$router.push('/PrintLabelv2')
            }
          }
        } catch (error) {
          console.log('result------', error.message);
        }
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/components/InScanRVPShipments/InScanRVPShipments.js